import createIcon from './createIcon';

export default createIcon(require('./tractor.svg'));